<template>

  <div>
    <div class="sport-link" v-if="sport !== undefined">
      <div class="label" @click="toggleDetails">{{ label }}</div>
    </div>
    <div v-else>-</div>
  </div>

</template>

<script>

export default {
  name: 'SportLink',
  props: ['id'],
  computed: {
    sport () {
      return this.$store.state.sports[this.id]
    },
    label () {
      return this.sport.labels['fr-FR'] || this.sport.labels['default']
    }
  },
  methods: {
    toggleDetails () {
      this.$router.push(`/sports/${this.id}`)
    }
  }
}

</script>

<style lang="scss" scoped>

  .label {
    display: inline;
    cursor: pointer;
    &:hover {
      color: #555;
    }
  }

  .id {
    display: inline;
    color: gray;
    margin-left: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/links/Sport.vue